import axios from 'axios'

export function getPlaidUserAccounts(sessionId: string): Promise<any> {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: process.env.REACT_APP_CONNECT_API_URL + '/report/plaid/user/accounts',
      headers: {
        'x-api-key': process.env.REACT_APP_CONNECT_API_KEY,
      },
      data: {
        sessionId,
      },
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err: any) => {
        console.error(err)
      })
  })
}
